var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 420,
    viewBox: "0 0 567 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_280_25342)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.247 254.25C345.203 210.69 374.386 213.532 384.733 220.398C405.229 233.774 444.623 224.728 452.638 199.178C460.654 173.628 462.492 133.575 429.648 117.18C396.803 100.785 358.424 123.536 292.946 151.709C227.469 179.883 218.107 157.224 179.912 169.404C141.717 181.584 127.132 277.594 169.547 295.374C211.961 313.155 268.803 308.699 311.247 254.25Z",
    fill: "url(#paint0_linear_280_25342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.247 254.25C345.203 210.69 374.386 213.532 384.733 220.398C405.229 233.774 444.623 224.728 452.638 199.178C460.654 173.628 462.492 133.575 429.648 117.18C396.803 100.785 358.424 123.536 292.946 151.709C227.469 179.883 218.107 157.224 179.912 169.404C141.717 181.584 127.132 277.594 169.547 295.374C211.961 313.155 268.803 308.699 311.247 254.25Z",
    stroke: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M451.315 305.545L433.664 317.035C432.814 317.588 432.301 318.534 432.301 319.549V417C432.301 418.657 433.644 420 435.301 420H456.762H478.301C479.958 420 481.301 418.657 481.301 417V319.552C481.301 318.536 480.786 317.588 479.934 317.035L462.214 305.537C458.899 303.386 454.627 303.389 451.315 305.545Z",
    fill: "url(#paint1_linear_280_25342)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8761 61.5737C95.3238 58.3907 102.063 58.3867 107.515 61.563L167.612 96.5786C171.927 99.0922 171.914 105.329 167.589 107.825L107.451 142.525C102.032 145.652 95.355 145.648 89.9396 142.514L29.9826 107.821C25.6673 105.324 25.6543 99.0978 29.9591 96.5825L89.8761 61.5737ZM107.011 62.4272C101.871 59.4326 95.5173 59.436 90.381 62.437L30.464 97.4458C26.8214 99.5741 26.832 104.843 30.4836 106.956L90.4406 141.649C95.5465 144.603 101.842 144.607 106.951 141.659L167.089 106.958C170.748 104.847 170.76 99.5699 167.11 97.4428L107.011 62.4272Z",
    fill: "url(#paint2_linear_280_25342)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3154 114.455L75.6642 102.965C74.8137 102.412 74.3008 101.466 74.3008 100.451V3C74.3008 1.34315 75.6439 0 77.3008 0H98.762H120.301C121.958 0 123.301 1.34315 123.301 3V100.448C123.301 101.464 122.786 102.412 121.934 102.965L104.214 114.463C100.899 116.614 96.6275 116.611 93.3154 114.455Z",
    fill: "url(#paint3_linear_280_25342)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.691 264L413.598 294.114",
    stroke: "#FFC37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.699 130L184.606 160.114",
    stroke: "#FFC37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.988 255L116.988 298",
    stroke: "#FFC37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.13 149L447.028 201.287C451.015 203.606 451.003 209.37 447.006 211.672L291.742 301.106C286.484 304.135 280.009 304.131 274.754 301.095L119.939 211.669C115.95 209.365 115.938 203.611 119.917 201.291L209.183 149.225",
    stroke: "#FFC37D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M452.248 96.2957L450.668 79.175C450.564 78.046 451.105 76.9548 452.067 76.3544L526.29 30.0268C527.816 29.0743 529.831 29.6697 530.595 31.2985L539.045 49.3278L548.566 66.0057C549.363 67.4005 548.919 69.1749 547.56 70.0311L477.282 114.313C476.318 114.92 475.095 114.93 474.122 114.338L457.006 103.919C454.303 102.274 452.538 99.4465 452.248 96.2957Z",
    fill: "url(#paint4_linear_280_25342)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M425.305 100.813V32.8507C425.305 29.024 429.429 26.616 432.762 28.4962L444.542 35.1417C445.921 35.9197 446.85 37.3049 447.047 38.8761L448.546 50.8712C448.664 51.8175 449.225 52.6515 450.058 53.1173L498.188 80.0528C501.348 81.8209 503.305 85.1582 503.305 88.7784V143.065C503.304 146.916 499.133 149.321 495.8 147.392L430.294 109.467C427.206 107.679 425.305 104.381 425.305 100.813ZM427.305 100.813C427.305 103.667 428.826 106.306 431.297 107.736L496.802 145.66C498.802 146.818 501.304 145.375 501.305 143.065V88.7784C501.305 85.8823 499.739 83.2124 497.212 81.7979L449.081 54.8624C447.694 54.0861 446.759 52.6964 446.562 51.1192L445.062 39.1241C444.945 38.1815 444.387 37.3507 443.56 36.8839L431.778 30.2384C429.779 29.1104 427.305 30.5548 427.305 32.8507V100.813Z",
    fill: "url(#paint5_linear_280_25342)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.72 118.419V207.542L283.863 251.824L283.354 252.125L207.988 207.542V118.419L282.845 74.1377L283.354 73.8359L358.72 118.419ZM209.988 206.401L282.572 249.338V163.677L209.988 120.739V206.401ZM284.572 163.42V249.079L356.72 206.401V120.74L284.572 163.42ZM210.953 118.987L283.354 161.816L355.755 118.988L283.354 76.1592L210.953 118.987Z",
    fill: "url(#paint6_linear_280_25342)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M447.876 277.574C453.324 274.391 460.063 274.387 465.515 277.563L525.612 312.579C529.927 315.092 529.914 321.329 525.589 323.825L465.451 358.525C460.032 361.652 453.355 361.648 447.94 358.514L387.983 323.821C383.667 321.324 383.654 315.098 387.959 312.582L447.876 277.574ZM465.011 278.427C459.871 275.433 453.517 275.436 448.381 278.437L388.464 313.446C384.821 315.574 384.832 320.843 388.484 322.956L448.441 357.649C453.547 360.603 459.842 360.607 464.951 357.659L525.089 322.958C528.748 320.847 528.76 315.57 525.11 313.443L465.011 278.427Z",
    fill: "url(#paint7_linear_280_25342)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M433.744 315.476L451.717 304.954C454.833 303.129 458.692 303.127 461.811 304.948L479.842 315.474C481.83 316.635 481.824 319.51 479.831 320.662L461.774 331.102C458.674 332.895 454.851 332.892 451.753 331.096L433.755 320.66C431.766 319.507 431.76 316.638 433.744 315.476Z",
    fill: "#FFC37D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M454.81 76.6281L472.951 86.8518C476.097 88.6252 478.043 91.9575 478.041 95.5694L478.031 112.448C478.03 114.75 475.543 116.193 473.544 115.052L455.427 104.711C452.318 102.937 450.395 99.6349 450.385 96.0548L450.337 79.2501C450.33 76.9508 452.807 75.4992 454.81 76.6281Z",
    fill: "#FFC37D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7443 99.4762L93.7167 88.9539C96.8335 87.1291 100.692 87.1267 103.811 88.9477L121.842 99.4743C123.83 100.635 123.824 103.51 121.831 104.662L103.774 115.102C100.674 116.895 96.8515 116.892 93.7531 115.096L75.7552 104.66C73.7665 103.507 73.7604 100.638 75.7443 99.4762Z",
    fill: "#FFC37D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8008 310.857V248.839C89.8008 245.397 93.5072 243.229 96.5068 244.916L141.958 270.483C144.949 272.165 146.801 275.331 146.801 278.763V341.999C146.801 345.481 143.016 347.644 140.017 345.876L94.4775 319.041C91.5796 317.334 89.8009 314.22 89.8008 310.857ZM90.8008 310.857C90.8009 313.866 92.3924 316.652 94.9854 318.18L140.523 345.015C142.857 346.39 145.801 344.707 145.801 341.999V278.763C145.801 275.692 144.144 272.86 141.468 271.355L96.0166 245.788C93.6835 244.476 90.8008 246.162 90.8008 248.839V310.857Z",
    fill: "url(#paint8_linear_280_25342)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3008 321.131V279.866C73.3009 276.035 77.4325 273.628 80.7656 275.517L110.231 292.215L110.521 292.386C113.483 294.198 115.301 297.426 115.301 300.915V342.976C115.301 346.852 111.081 349.253 107.748 347.274L78.1953 329.73C75.1609 327.928 73.3008 324.66 73.3008 321.131ZM75.3008 321.131C75.3008 323.954 76.7891 326.568 79.2168 328.01L108.77 345.555C110.769 346.742 113.301 345.301 113.301 342.976V300.915C113.301 298.124 111.847 295.541 109.478 294.091L109.245 293.954L79.7803 277.257C77.7804 276.124 75.3009 277.568 75.3008 279.866V321.131Z",
    fill: "url(#paint9_linear_280_25342)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.047 309.857L102.731 325.229C102.779 326.319 102.232 327.349 101.302 327.919L10.2837 383.741C8.75086 384.681 6.74109 384.071 5.98971 382.437L-0.191895 368.998L-7.20999 356.496C-7.99898 355.09 -7.53639 353.313 -6.16242 352.47L85.2315 296.418C86.1855 295.833 87.386 295.828 88.3452 296.404L97.208 301.73C100.081 303.457 101.898 306.508 102.047 309.857Z",
    fill: "url(#paint10_linear_280_25342)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M454.662 99.1133L367.559 151.113",
    stroke: "#FFC37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3008 313.882V298.909C84.3008 295.834 87.6256 293.909 90.2922 295.439L99.7815 300.887C102.577 302.492 104.301 305.469 104.301 308.692V323.927C104.301 327.038 100.905 328.958 98.2393 327.355L88.6624 321.595C85.956 319.967 84.3008 317.04 84.3008 313.882Z",
    fill: "#FFC37D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_280_25342",
    x: 43.2944,
    y: 11.1665,
    width: 514.766,
    height: 394.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_280_25342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_25342",
    x1: 199.084,
    y1: 325.814,
    x2: 222.36,
    y2: 121.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_280_25342",
    x1: 456.801,
    y1: 387,
    x2: 456.801,
    y2: 302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2C",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_280_25342",
    x1: 26.7383,
    y1: 102.025,
    x2: 170.84,
    y2: 102.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_280_25342",
    x1: 98.8008,
    y1: 33,
    x2: 98.8008,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2C",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_280_25342",
    x1: 517.311,
    y1: 63.0015,
    x2: 461.311,
    y2: 97.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2C",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_280_25342",
    x1: 425.305,
    y1: 87.9578,
    x2: 503.305,
    y2: 87.9578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_280_25342",
    x1: 207.988,
    y1: 162.98,
    x2: 358.72,
    y2: 162.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_280_25342",
    x1: 384.738,
    y1: 318.025,
    x2: 528.84,
    y2: 318.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_280_25342",
    x1: 89.8008,
    y1: 295.419,
    x2: 146.801,
    y2: 295.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_280_25342",
    x1: 73.3008,
    y1: 311.421,
    x2: 115.301,
    y2: 311.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B798F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_280_25342",
    x1: 39.3081,
    y1: 341.998,
    x2: 104.946,
    y2: 304.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2C",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.b2fc2b581c1903fe5bc63c43bd24cf47.svg";
export { ForwardRef as ReactComponent };